<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            .opponents_title
                | {{ $i18n.t('battle.battle_chooseOpponent') }}
            cs-search-input.opponents__search(
                v-model="form.fullName"
                :placeholder="$i18n.t('battle.battle_findOpponent')"
                @search="sendForm"
            )
            .opponents__block
                v-infinite-scroll.opponents__list(
                    @bottom="loadOpponents"
                )
                    .opponents__players-not-found(v-if="opponents.length === 0")
                        | {{ $i18n.t('battle.battle_playersNotFound') }}
                    template(v-for="opponent in sortedOpponents")
                        .opponent(
                            :ref='opponent.id'
                            @scroll='loadOpponents'
                            @click="inviteOpponent(opponent.id)"
                            :class="{'opponent_blocked': opponent.isInvitationBlocked}"
                        )
                            .opponent__avatar
                                img(:src="opponent.avatar")
                            .opponent__full-name
                                | {{ opponent.fullName + " (" + opponent.city + ") " }}
                                .opponent__online
                    .opponents-loader(v-if='this.form.page !== lastPage')
                        cs-loader
            .opponents__buttons-container
                cs-button.opponents__button(color="blue" @click="$router.push({name: 'battle-trainings:index'})")
                    | {{ $i18n.t('battle.battle_opponents_goBackToTrainings') }}
</template>

<script>
    /*eslint-disable*/
    import BattleApi from '../../../api/battle';
    import MessageApi from '../../../api/communication/message';
    import { mapState } from 'vuex';
    import _ from 'lodash';

    export default {
        props: {
            battleId: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                opponents: [],
                isLoading: true,
                form: {
                    fullName: '',
                    amountOfElements: 10,
                    page: 1,
                    course_type: null,
                },
                lastPage: null,
            };
        },
        mounted() {
            if (this.battleId < 1) {
                this.$router.push({ name: 'dashboard' });
            }
            this.form.course_type = _.kebabCase(this.course);
            this.sendForm();
        },
        watch: {
            'form.fullName'() {
                this.updateList();
            },
        },
        methods: {
            loadOpponents() {
                if (this.form.page < this.lastPage) {
                    this.form.page++;
                } else {
                    return;
                }
                BattleApi.opponentsForTraining(this.form).then(data => {
                    let newOpponents = data.opponents.data;
                    newOpponents.forEach(item => {
                        item.fullName = `${item.firstName} ${item.lastName}`;
                    });
                    this.opponents = _.uniqBy(this.opponents.concat(newOpponents), 'id');
                    return data.opponents.data[0].id;
                });
            },
            sendForm() {
                this.isLoading = true;
                BattleApi.opponentsForTraining(this.form).then(data => {
                    this.opponents = data.opponents.data;
                    this.form.page = data.opponents.currentPage;
                    if (!data.opponents.data.length) {
                        this.lastPage = 1;
                    } else {
                        this.lastPage = data.opponents.lastPage;
                    }
                    this.opponents.forEach(item => {
                        item.fullName = `${item.firstName} ${item.lastName}`;
                    });
                    this.isLoading = false;
                });
            },
            updateList: _.debounce(function() {
                this.form.page = 1;
                this.sendForm();
            }, 1000),
            inviteOpponent(opponentId) {
                BattleApi.opponentsForTraining(this.form).then(data => {
                    if (!data.opponents.data.find(user => user.id == opponentId)) {
                        this.$toasted.error(this.$i18n.t('battle.battle_invitation_ignored'));
                        this.sendForm();
                        return;
                    }
                    let opponent = _.find(this.opponents, { id: opponentId });
                    if (opponent.isInvitationBlocked) {
                        return;
                    }
                    this.$router.push({
                        name: 'battles:opponent',
                        params: { battleId: this.battleId, isTraining: true, opponentId: opponentId },
                    });
                });
            },
        },
        computed: {
            ...mapState({
                course: state => state.trainer.course,
            }),
            sortedOpponents() {
                return _.sortBy(this.opponents, opponent => opponent.isInvitationBlocked);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .box {
        box-sizing: border-box;
        width: 100%;
        border-radius: 40px;
        background: #ffffff;
        box-shadow: 0 0 54px #51a552;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 30px;
        @media screen and (max-width: 575px) {
            border-radius: 0;
            box-shadow: none;
            padding: 0;
        }
    }

    .box-body {
        box-sizing: border-box;
        width: 100%;
        height: auto;
        padding: 30px 20px;
        background-color: $hsl-color-gray-98_4;
        border-radius: $border-radius-20;
        @include media($sm) {
            height: 467px;
            width: 576px;
            padding: 30px;
        }
        @include media($md) {
            width: 557px;
        }
        @include media($lg) {
            width: 600px;
        }
    }

    .opponents_title {
        font-size: 22px;
        font-weight: 500;
        text-align: center;
        @include stack-space($space-base);
    }

    .opponents__search {
        @include stack-space($space-base);
    }

    .opponents__block {
        height: 220px;
        border: 1px solid $hsl-color-gray-74;
        border-radius: $border-radius-5;
        background-color: $x-color-white;
        padding: 5px;
        @include stack-space($space-large);
    }

    .opponents__list {
        height: 100%;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #c4c4c4;
        }

        &::-webkit-scrollbar-track {
            border-radius: 10px;
        }
    }

    .opponents__players-not-found {
        margin: 10px;
        color: $hsl-color-gray-51;
        font-weight: 300;
    }

    .opponent {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 15px 10px 0;
        border-radius: $border-radius-5;
        cursor: pointer;
        &:hover {
            background-color: #63be63;
            transition: all 0.7s ease;
        }
    }

    .opponent__avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin: 0 10px;
        overflow: hidden;
        background-color: $hsl-color-gray-97;
        img {
            height: 100%;
        }
    }

    .opponent__full-name {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #333333;
        margin-right: 10px;
        max-width: 68%;
        @include media($sm) {
            max-width: 85%;
        }
        position: relative;
    }

    .opponent__online {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $hsl-color-green-58;
        position: absolute;
        right: -18px;
        top: 6px;
    }

    .opponent_blocked {
        opacity: 0.4;
        background-color: $hsl-color-gray-88;
        pointer-events: none;
    }

    .opponents__buttons-container {
        display: flex;
        justify-content: center;
    }
</style>
